import React from "react";
import { Link } from "react-router-dom";

import QR from "../image/change01.png";
import Phone from "../image/change02.png";
import DT from "../image/change03.png";

const styles = {
  noMargin: {
    margin: "0px",
  },
};

class Modal extends React.Component {
  render() {
    return (
      <>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/jquery-modal/0.9.1/jquery.modal.min.css"
        />
        <div
          className="jquery-modal blocker current"
          style={{ display: this.props.show ? "block" : "none" }}
        >
          <div
            id="change_modal"
            className="modal modalWrap"
            style={{ display: this.props.show ? "inline-block" : "none" }}
          >
            <div className="change_wrap">
              <p style={{ margin: 0 }}>측정자 변경</p>
              <div>
                <ul>
                  <li>
                    <Link to="#">
                      <img src={QR} alt="QR 아이콘" />
                      <p style={styles.noMargin}>QR</p>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <img src={Phone} alt="전화번호 아이콘" />
                      <p style={styles.noMargin}>전화번호</p>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <img src={DT} alt="군번 아이콘" />
                      <p style={styles.noMargin}>군번</p>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <Link to="#" onClick={this.props.toggle} className="close-modal ">
              Close
            </Link>
          </div>
        </div>
      </>
    );
  }
}

export default Modal;
